import { atom } from "recoil";

export const defaultStoreState = {};

const storeState = atom<Record<string, any>>({
    key: "storeState",
    default: {},
});

export default storeState;
